import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';  // Import eye icons
import plutonicLogo from '../assets/images/plutonicLogo.svg';
import plutonicSmallName from '../assets/images/plutonicSmallName.svg';
import Env from '../runtimeEnv';

function LoginForm({ setCurrentNickname, formType, setFormType, onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    hasNumber: false,
    hasSpecialChar: false,
    hasUppercase: false,
    hasLowercase: false,
  });

  useEffect(() => {
    // Define password validation patterns
    const requirements = {
      minLength: /^(?=.{8,}).*$/,
      hasNumber: /^(?=.*[0-9]).*$/,
      hasSpecialChar: /^(?=.*[!@#$%^&*]).*$/,
      hasUppercase: /^(?=.*[A-Z]).*$/,
      hasLowercase: /^(?=.*[a-z]).*$/,
    };

    setPasswordRequirements({
      minLength: requirements.minLength.test(newPassword),
      hasNumber: requirements.hasNumber.test(newPassword),
      hasSpecialChar: requirements.hasSpecialChar.test(newPassword),
      hasUppercase: requirements.hasUppercase.test(newPassword),
      hasLowercase: requirements.hasLowercase.test(newPassword),
    });
  }, [newPassword]);

 // Guest nickname
  
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setError('');

  //   const trimmedPassword = password.trim();

  //   try {
  //     const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/login`, {
  //       email,
  //       password: trimmedPassword,
  //     }, { withCredentials: true });

  //     if (response.data.newTemporaryPasswordSent) {
  //       setError("Your temporary password has expired. A new one has been sent to your email.");
  //       setLoading(false);
  //       return;
  //     }

  //     if (response.data.challenge === 'NEW_PASSWORD_REQUIRED') {
  //       setShowNewPasswordForm(true);
  //     } else {
  //       const { PlutonicuserID, nickname } = response.data;
  //       setCurrentNickname(nickname || 'Guest');
  //       localStorage.setItem('nickname', nickname || 'Guest');
  //       localStorage.setItem('PlutonicuserID', PlutonicuserID || 'unknown');
  //       onLoginSuccess(nickname || 'Guest', PlutonicuserID || 'unknown');
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  
const randomNicknames = [
  "Mind Explorer",
  "Growth Seeker",
  "Healing Hero",
  "Journey Navigator",
  "Balance Warrior",
  "Insight Chaser",
  "Calm Creator",
  "Resilience Builder"
];

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  const trimmedPassword = password.trim();

  try {
      const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/login`, {
          email,
          password: trimmedPassword,
      }, { withCredentials: true });

      if (response.data.newTemporaryPasswordSent) {
          setError("Your temporary password has expired. A new one has been sent to your email.");
          setLoading(false);
          return;
      }

      if (response.data.challenge === 'NEW_PASSWORD_REQUIRED') {
          setShowNewPasswordForm(true);
      } else {
          const { PlutonicuserID, nickname, userType } = response.data;
          

          // If the user doesn't have a nickname, assign a random one
          let assignedNickname = nickname || randomNicknames[Math.floor(Math.random() * randomNicknames.length)];

          // If a new random nickname is assigned, update it in the backend
          if (!nickname) {
              try {
                  await axios.put(`${Env.REACT_APP_PYTHON_API_URL}/api/update-nickname`, {
                      PlutonicuserID,
                      newNickname: assignedNickname
                  }, { withCredentials: true });

                  
              } catch (error) {
                  console.error("Error updating nickname:", error);
              }
          }

          setCurrentNickname(assignedNickname);
          localStorage.setItem('nickname', assignedNickname);
          localStorage.setItem('PlutonicuserID', PlutonicuserID || 'unknown');
          localStorage.setItem('userType', userType || 'user');

          onLoginSuccess(assignedNickname, PlutonicuserID, userType || 'unknown');
      }
  } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
  } finally {
      setLoading(false);
  }
};



  const handleNewPasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
  
    const trimmedNewPassword = newPassword.trim();
  
    try {
      const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/set_new_password`, {
        email,
        newPassword: trimmedNewPassword,  // Use trimmed new password
      }, { withCredentials: true });
  
      if (response.data.message === 'Password updated successfully') {
        const loginResponse = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/login`, {
          email,
          password: trimmedNewPassword,  // Use trimmed new password
        }, { withCredentials: true });
  
        const { PlutonicuserID, nickname } = loginResponse.data;
        setCurrentNickname(nickname || '');
        localStorage.setItem('nickname', nickname || '');
        localStorage.setItem('PlutonicuserID', PlutonicuserID);
  
        onLoginSuccess(nickname || '', PlutonicuserID);
      } else {
        setError('Failed to set password. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to set new password.');
    } finally {
      setLoading(false);
    }
  };

  

 
 const preventSpace = (e) => {
  if (e.key === ' ') {
    e.preventDefault();
  }
};


return (
  <div className='bg-black bg-opacity-80 p-8 rounded-3xl shadow-lg w-[350px] text-white text-center'>
    {showNewPasswordForm ? (
  <>
    <h2 className='text-2xl font-bold mb-6'>Set New Password</h2>
    <form onSubmit={handleNewPasswordSubmit} className='space-y-2'>
      <div className="relative">
        <input
          type={showNewPassword ? 'text' : 'password'}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value.trim())}
          onKeyDown={preventSpace}
          placeholder="New Password"
          className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
          required
        />
        <button
          type="button"
          className="absolute inset-y-0 right-3 flex items-center text-gray-400"
          onClick={() => setShowNewPassword((prev) => !prev)}
        >
          {showNewPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      {/* Password Requirements */}
      <div className="text-left small-text mt-2">
        <p>Password must meet the following requirements:</p>
        <ul className="list-disc ml-5 mt-1">
          <li className={passwordRequirements.minLength ? 'text-green-500' : 'text-red-500'}>
            Minimum length: 8 characters
          </li>
          <li className={passwordRequirements.hasNumber ? 'text-green-500' : 'text-red-500'}>
            Contains at least 1 number
          </li>
          <li className={passwordRequirements.hasSpecialChar ? 'text-green-500' : 'text-red-500'}>
            Contains at least 1 special character
          </li>
          <li className={passwordRequirements.hasUppercase ? 'text-green-500' : 'text-red-500'}>
            Contains at least 1 uppercase letter
          </li>
          <li className={passwordRequirements.hasLowercase ? 'text-green-500' : 'text-red-500'}>
            Contains at least 1 lowercase letter
          </li>
        </ul>
      </div>

      {error && <p className="text-red-500">{error}</p>}
      <button
        type="submit"
        className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
        disabled={loading}
      >
        {loading ? 'Setting Password...' : 'Submit'}
      </button>
    </form>
  </>
) : (

      <>
        <h2 className='text-2xl font-bold mb-6'>Login</h2>
        <form onSubmit={handleSubmit} className='space-y-2'>
          <div className='relative'>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              placeholder='Email'
              className='w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]'
              required
            />
          </div>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value.trim())}
              onKeyDown={preventSpace}
              placeholder="Password"
              className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
              required
            />
            <button
              type="button"
              className="absolute inset-y-0 right-3 flex items-center text-gray-400"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          {error && <p className="text-red-500">{error}</p>}
          <button
            type="submit"
            className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'ENTER'}
          </button>
        </form>
        <p 
            className="mt-4 text-sm text-left cursor-pointer hover:underline" 
            onClick={() => {
              setFormType('reset');
              localStorage.setItem('formType', 'reset');
              // console.log("Form type set to reset and saved in localStorage");
            }}
          >
            Reset Password?
          </p>
      </>
    )}
    <div className="mt-2 flex items-center justify-center space-x-2">
      <img src={plutonicLogo} alt="Plutonic Logo" className="w-[50px] h-[30px]" />
      <img src={plutonicSmallName} alt="company name" className="w-20 h-20" />
    </div>
  </div>
);
}


export default LoginForm;
